import * as angular from 'angular';

interface ISvgScope extends angular.IScope {
    src: string;
}

class SvgDirective implements angular.IDirective {
    readonly replace = true;
    readonly transclude = true;
    readonly restrict = 'E';
    readonly scope = {
        src: '@'
    };

    readonly template = '<span class="fc-svg" ng-transclude></span>';

    readonly link: angular.IDirectiveLinkFn;

    constructor() {
        this.link = this._link.bind(this);
    }

    private _link(
        scope: ISvgScope,
        element: JQuery,
        _attributes: angular.IAttributes,
        _controller: angular.IController,
        transclude: angular.ITranscludeFunction
    ): void {
        transclude(() => {
            if (scope.src) {
                // Get the SVG markup and append to the template element
                element.load(scope.src, (_response, status) => {
                    if (status === 'error') {
                        element.replaceWith(`<span>Unable to load '${scope.src}'.</span>`);
                    }
                });
            } else {
                element.replaceWith(
                    `<span>A 'src' attribute is required to load an SVG file.</span>`
                );
            }
        });
    }
}

const SvgDirectiveFactory: angular.IDirectiveFactory = () => new SvgDirective();

export { SvgDirectiveFactory };
